import { render, staticRenderFns } from "./booking-details-tab.vue?vue&type=template&id=dd9c7e86&scoped=true&"
import script from "./booking-details-tab.vue?vue&type=script&lang=js&"
export * from "./booking-details-tab.vue?vue&type=script&lang=js&"
import style0 from "./booking-details-tab.vue?vue&type=style&index=0&id=dd9c7e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9c7e86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChipGroup})
